import { render, staticRenderFns } from "./printshippinglabel.vue?vue&type=template&id=6c6bc9b6&"
import script from "./printshippinglabel.vue?vue&type=script&lang=js&"
export * from "./printshippinglabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports